import React from "react";

const Copyright = ()=>{
    return (
        <div className="copyright">&copy; 2020 helloyvonne. Inspired by Elijah Louis</div>
    );
};

export default Copyright